import { combineReducers } from "redux";

import curriculoReducer from './curriculo-reducer';
import aguardarReducer from "./aguardar-reducer";
import erroReducer from "./erro-reducer";
import usuarioReducer from './usuario-reducer';
import manutencaoReducer from "./manutencao-reducer";
import cadastroMensagensReducer from "./cadastro-mensagens-reducer";

export default combineReducers({
    cadastroMensagens: cadastroMensagensReducer,
    aguardar: aguardarReducer,
    erro: erroReducer,
    curriculo: curriculoReducer,
    usuario: usuarioReducer,
    manutencao: manutencaoReducer, 
})